module.exports = __webpack_public_path__ + "images/74d4eb1f114245a2cde30a0e732b7294.svg";